jQuery(document).ready(function ($) {
  $(".topper-main--carousel").each(function () {
    var $slider = $(this);

    if ($slider.find(".page-topper-slide").length < 2) {
      return;
    }

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      pauseOnHover: true,
      rows: 0,
      infinite: true,
    });
  });
});
